import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskEditedAvailability_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from '../../Helpers/ActivityLogBase';

interface Fragments {
  activityLog: ActivityLogTaskEditedAvailability_ActivityLogFragment;
}

const ActivityLogTaskEditedAvailability: FCWithFragments<Fragments> = ({ activityLog }) => {
  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.editedAvailability"
    />
  );
};

ActivityLogTaskEditedAvailability.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskEditedAvailability_activityLog on ActivityLog {
      id

      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskEditedAvailability;
